import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { CPMemberService } from "src/app/cp-member/services/CPMember.service";
@Component({
  selector: "app-claim-id-card",
  templateUrl: "./claim-id-card.component.html",
  styleUrls: ["./claim-id-card.component.scss"],
  // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClaimIdCardComponent {
  @Input() property1 = "Variant9";
  claimDetails ;
  id = this.route.snapshot.paramMap.get('id');
  isClaimDetailsLoaded = false;
  constructor(private route: ActivatedRoute,
    private cpMemberService: CPMemberService,
    private router: Router,

  ){

  }

  ngOnInit(){
    // console.log(this.id)
    this.id = this.route.snapshot.paramMap.get('id');
    this.getClaimDetails();
  }

  getClaimDetails(){
    this.cpMemberService
      .getClaimsDetails(this.id)
      .then(x => {
        this.claimDetails = x;
        this.isClaimDetailsLoaded = true;
      })
      .catch(x => {
        // console.log('error');
        this.isClaimDetailsLoaded = true;
      });
  }

  redirectToUploadDocuments(id) {
    this.router.navigate(['/cp-member/upload-documents', id]);
  }
}
